export default {
  buttons: {
    signup: 'Înregistrează-te',
    login: 'Conectează-te',
  },
};
